import Api from "@/services/service-v2";


const getEvents = async () => {
    const res = await Api().$http.get(`/events/events`);
    return res.data;
};

const getMappings = async () => {
    const res = await Api().$http.get(`/events/mappings`);
    return res.data;
};

const createMappings = async (data) => {
    const res = await Api().$http.post(`/events/mappings`, data);
    return res.data;
};

const updateMappings = async (id, data) => {
    const res = await Api().$http.put(`/events/mappings/${id}`, data);
    return res.data;
};

const deleteMappings = async (id) => {
    const res = await Api().$http.delete(`/events/mappings/${id}`);
    return res.data;
}


export {
    getEvents,
    getMappings,
    createMappings,
    updateMappings,
    deleteMappings
}
